export default "__VITE_ASSET__5c7661c0__"